import { useId, type InputHTMLAttributes } from 'react';
import { cx } from '../utils/cx.js';
import styles from './Switch.module.css';

export type SwitchProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  label?: string;
};

export function Switch({ label, id, className, disabled, ...rest }: SwitchProps) {
  const uid = useId();
  const sid = id ?? rest.name ?? uid;
  return (
    <label className={cx(styles.wrap, disabled && styles.disabled, className)} htmlFor={sid}>
      <input id={sid} type="checkbox" className={styles.input} role="switch" disabled={disabled} {...rest} />
      <span className={styles.track} aria-hidden>
        <span className={styles.thumb} />
      </span>
      {label ? <span className={styles.label}>{label}</span> : null}
    </label>
  );
}
